module.exports = "https://img1.huilianyi.com/e/icon1.e84dbad2f9.appcore.png";